// jsPDF disclaimer decoration. Call right before doc.save() in every PDF
// generator. Adds:
//   • A small amber header strip ("NOT FDA CLEARED · CLINICAL DECISION SUPPORT ONLY")
//     to every page.
//   • A diagonal grey watermark ("DRAFT — CLINICIAN REVIEW REQUIRED") behind
//     content on every page.
//   • A bottom footer block with the full disclaimer line on the last page.
//
// The function is idempotent on the page count — it always discovers the
// current page count and decorates each page in turn.

import {
  PDF_HEADER_TEXT,
  PDF_WATERMARK_TEXT,
  PDF_FOOTER_TEXT,
  DISCLAIMER_VERSION,
} from "./disclaimer";

export function decoratePdfWithDisclaimer(doc) {
  if (!doc) return;
  try {
    const pageCount = doc.internal.getNumberOfPages();
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();

    for (let p = 1; p <= pageCount; p++) {
      doc.setPage(p);

      // ── Header strip ──────────────────────────────────────
      const strokePrev = doc.getDrawColor?.();
      doc.setFillColor(255, 240, 195); // soft amber
      doc.rect(0, 0, pageW, 18, "F");
      doc.setTextColor(140, 90, 0);
      doc.setFont("helvetica", "bold");
      doc.setFontSize(8);
      doc.text(PDF_HEADER_TEXT, pageW / 2, 12, { align: "center" });

      // ── Diagonal watermark ────────────────────────────────
      doc.setTextColor(220, 200, 130); // light gold
      doc.setFont("helvetica", "bold");
      doc.setFontSize(46);
      try {
        doc.text(PDF_WATERMARK_TEXT, pageW / 2, pageH / 2, {
          align: "center",
          angle: 30,
        });
      } catch (_) {
        // Older jsPDF versions ignore { angle }; fall back to centered horizontal text.
        doc.text(PDF_WATERMARK_TEXT, pageW / 2, pageH / 2, { align: "center" });
      }

      // ── Footer line ───────────────────────────────────────
      doc.setTextColor(110, 80, 30);
      doc.setFont("helvetica", "normal");
      doc.setFontSize(7);
      const footerWidth = pageW - 60;
      const lines = doc.splitTextToSize(PDF_FOOTER_TEXT, footerWidth);
      let fy = pageH - 24;
      lines.forEach((ln, i) => {
        doc.text(ln, pageW / 2, fy + i * 8, { align: "center" });
      });
      doc.text(
        `Page ${p} of ${pageCount}  ·  Disclaimer ${DISCLAIMER_VERSION}`,
        pageW / 2,
        pageH - 10,
        { align: "center" }
      );

      // restore stroke color
      if (typeof strokePrev !== "undefined") {
        try { doc.setDrawColor(strokePrev); } catch (_) {}
      }
      // restore text fill for downstream pages (defensive — should not be needed)
      doc.setTextColor(40);
      doc.setFont("times", "normal");
    }
  } catch (e) {
    // Never let decoration crash the export
    // eslint-disable-next-line no-console
    console.warn("decoratePdfWithDisclaimer failed:", e);
  }
}
